import React, { useEffect } from "react"
import Typography from "@mui/material/Typography"
import { useNavigate } from "react-router-dom"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Page from "../../../MarlinSurf/Page/Page"

const PageNotFound = () => {
  const navigate = useNavigate()

  useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
  }, [])

  return (
    <Page hideNavBar minimalFooter>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          backgroundColor: "#0d1b2a",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: "#c8b99a",
            letterSpacing: "0.25em",
            fontSize: "0.75rem",
            fontFamily: "'Josefin Sans', sans-serif",
            mb: 2,
          }}
        >
          Marlin Surfboards
        </Typography>
        <Typography
          sx={{
            fontFamily: "'Kenilla', 'Playfair Display', serif",
            fontSize: { xs: "6rem", md: "8rem" },
            color: "#f5f2ec",
            lineHeight: 1,
          }}
        >
          404
        </Typography>
        <Typography
          sx={{
            fontFamily: "'Josefin Sans', sans-serif",
            fontSize: "1rem",
            color: "rgba(255,255,255,0.5)",
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            mt: 1,
            mb: 4,
          }}
        >
          Page not found
        </Typography>
        <Button
          variant="text"
          onClick={() => navigate("/")}
          sx={{
            color: "#c8b99a",
            fontFamily: "'Josefin Sans', sans-serif",
            fontSize: "0.8rem",
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            borderBottom: "1px solid rgba(200,185,154,0.3)",
            borderRadius: 0,
            px: 3,
            pb: 0.5,
            "&:hover": { color: "#f5f2ec", borderBottom: "1px solid #f5f2ec" },
          }}
        >
          Back to Home
        </Button>
      </Box>
    </Page>
  )
}

export default PageNotFound
